import React from "react";
import Logo from '../../assets/Images/Docusafe_logo.webp';

export default function CustomerSleeveHeader({ recipientName, dueDate }) {
  return (
    <header className="customer-sleeve-header d-flex align-items-center justify-content-between px-4 py-3 bg-white shadow-lg rounded-0">
      <div className="d-flex align-items-center">
        <img src={Logo} alt="docusafe_logo" className="docusafe_logo" />
      </div>
      <div className="text-end">
        <div className="fw-semibold">{recipientName}</div>
        {dueDate && (
          <div className="text-danger small">
            Due Date: {new Date(dueDate).toLocaleDateString()}
          </div>
        )}
      </div>
    </header>
  );
} 